// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3W6FN","footer":"ModalError_footer__3t_Qw"};